import "./NavBar.css";
import {NavLink} from "react-router-dom";
import {useUserContext} from "../../../context/userContext/context";
import {useEffect} from "react";
import Loader from "../loader/Loader";

// accessLevel: 11 = admin (all tabs), 2 = SEO only, 3 = Reviews only, 4 = Reviews + SEO
const REVIEWS_LEVELS = [11, 3, 4]
const SEO_LEVELS = [11, 2, 4]

const NavBar = () => {

    const {user, userLoading, getUserData, logoutUser} = useUserContext()
    useEffect(() => {
        getUserData()
    }, [])
    console.log(user)
    if (userLoading) return <nav><Loader/></nav>
    if (!user || user.needAuth) return <nav>
        <NavLink to={'/login'}
                 className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
            Login
        </NavLink>
    </nav>

    return <nav>


        {user.accessLevel > 8 && <>
            <NavLink
                to={'/dashboard'}
                className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
                User Dashboard
            </NavLink>

            <NavLink
                to={'/linksPanel'}
                className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
                Links Panel
            </NavLink>
            <NavLink
                to={'/manualPanel'}
                className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
                Manual Panel
            </NavLink>
            <NavLink
                to={'/createTasksPanel'}
                className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
                Create Task
            </NavLink></>}

        {REVIEWS_LEVELS.includes(user.accessLevel) && <NavLink
            to={'/reviewsPanel'}
            className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
            Reviews
        </NavLink>}
        {SEO_LEVELS.includes(user.accessLevel) && <NavLink
            to={"/seoPanel"}
            className={({isActive, isPending}) => isPending ? "navLink" : isActive ? "navLink active" : "navLink"}>
            SEO
        </NavLink>}
        <NavLink
            to={'/login'}>
            <div className={'navLink'} onClick={logoutUser}>Logout</div>
        </NavLink>
    </nav>;
};
export default NavBar;
